import styled, { css } from 'styled-components';
import { Colors } from '../../../ui';

const Base = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    padding: .75rem;
    border-radius: .25rem;
    background: #FFF;
    border: solid .0625rem ${Colors.border};
    border-bottom: solid .25rem ${Colors.border};
    user-select: none;
`;

const Left = styled.div`
    flex: 0 0 auto;
`;

const Main = styled.div`
    flex: 1 1 auto;
    color: ${Colors.text};
    font-size: 1rem;
    font-weight: 380;
`;

const Icon = styled.img`
    width: 3rem;
    height: 3rem;
    border-radius: .125rem;
`;

const Title = styled.div`
    flex: 1 1 auto;
    color: ${Colors.primaryText};
    font-size: 1rem;
    font-weight: 420;
`;

const Info = styled.div`

`;

export const JiraProject = Object.assign(Base, {
    Left,
    Main,
    Icon,
    Title,
    Info,
});

export const JiraProjectSelectableFrame = styled.div<{ active?: boolean }>`
    display: flex;
    cursor: pointer;
    border-radius: .25rem;

    ${JiraProject} {
        flex: 1 1 auto;
    }

    &:hover {
        box-shadow: 0 0 0 .25rem ${Colors.primaryLight};
        ${JiraProject} { border-color: transparent; }
    }
    &:active {
        box-shadow: 0 0 0 .25rem ${Colors.primary};
        ${JiraProject} { border-color: transparent; }
    }
    ${p => p.active && css`
        box-shadow: 0 0 0 .25rem ${Colors.primary};
        ${JiraProject} { border-color: transparent; }
    `}
`;